import { deleteObjective } from "src/services/api/opportunities";
import { Button, Modal, Typography } from "../../basics";
import { DeleteObjectiveModalProps } from "./types";
import { useState } from "react";
import { useOpportunitiesStore } from "src/store";


const DeleteObjectiveModal = ({objectiveId, objectiveTitle, open, ...props}: DeleteObjectiveModalProps) => {

    const [loading, setLoading] = useState(false);
    const triggerRefresh = useOpportunitiesStore((s: any) => s.triggerRefresh);
    const confirmDelete = async () => {
        try{
            setLoading(true);
            await deleteObjective(objectiveId);
        }
        catch(error){
            console.error("Erro ao deletar o objetivo:", error);
        }
        finally{
            setLoading(false);
            props.onClose();
            triggerRefresh();
        }
    }
    return (
        <Modal
            {...props}
            open={open}
            title="Deletar Objetivo"
        >
            <Typography>
                Tem certeza que deseja deletar o objetivo "{objectiveTitle}"? Esta ação não pode ser desfeita.
            </Typography>
            <Button onClick={confirmDelete} variant="contained" sx={{ mt: 2, float: 'right' }} disabled={loading}>
                Deletar Objetivo
            </Button>
        </Modal>
    )
}

export { DeleteObjectiveModal }